import Carousel from "react-multi-carousel";
import verifytick from "../../../assets/verify-tick.png";
import { TEMPLE_CARD_CAUROSAL_RESPONSIVE } from "../../../utils/Constants";
import { Box, Typography } from "@mui/material";
import templeLogo from "../../../assets/temple-logo-icon.png";
import { Link } from "react-router-dom";
import StarOutlinedIcon from "@mui/icons-material/StarOutlined";
import "./TempleDetailsCard.scss";
import ImageView from "../../ImageView/ImageView";
import OverlayText from "../../OverlayText/overlayText";

export default function TempleDetailsCard(props: any) {
  const { templePictures, templeCardImage } = props;

  const _templePictures = templePictures?.length
    ? templePictures.filter((_tmpImg: any) => Boolean(_tmpImg?.pictureUrl))
    : [];

  return (
    <Box key={props.id} className="templeCardBox">
      <Box
        className="templeTop"
        onClick={() => props.selectTemple(props.templeData)}
      >
        <Box className="templeProfile">
          <ImageView
            src={props.templeImage}
            alt="Temple Profile"
            width={40}
            height={40}
            breakpoints={[40]}
            sizes="(max-width: 768px) 40px, 60px"
          />
        </Box>
        <Box className="templeTitle">
          <Typography>
            {props.templeName}{" "}
            {props.verificationStatus === "VERRIFIED" ? (
              <img src={verifytick} alt="verify tick" />
            ) : null}
          </Typography>
          <Box className="ratings">
            <StarOutlinedIcon />
            <Typography>
              <span>{props.googleData?.rating}</span>{" "}
              <span className="ratingCount">
                ({props.googleData?.user_ratings_total}+ ratings)
              </span>
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box className="templeImage">
        {templeCardImage ? (
          <Box className="templeListParent mbAdd">
            <ImageView
              src={templeCardImage}
              alt="Temple Card Image"
              onClick={() => props.selectTemple(props.templeData)}
            />
            <OverlayText
              leftSideTextOverlay={props.overlayText?.leftSideTextOverlay ?? ""}
              rightSideTextOverlay={
                props.overlayText?.rightSideTextOverlay ?? ""
              }
              overlayCss={props.overlayCss ?? {}}
            />
          </Box>
        ) : (
          <Carousel
            responsive={TEMPLE_CARD_CAUROSAL_RESPONSIVE || {}}
            swipeable={true}
            draggable={true}
            showDots={true}
            keyBoardControl={true}
            removeArrowOnDeviceType={["tablet", "mobile"]}
            className="templeListCardCarousel"
          >
            {_templePictures.map((item2: any, id: number) => (
              <Box key={id} className="templeListParent">
                <ImageView
                  src={item2?.pictureUrl ?? ""}
                  alt="Temple Image"
                  onClick={() => props.selectTemple(props.templeData)}
                />
              </Box>
            ))}
          </Carousel>
        )}
      </Box>

      {/* Description */}
      <Box
        className="templeDescription"
        onClick={() => props.selectTemple(props.templeData)}
      >
        <Typography>{props.descriptions}</Typography>
      </Box>

      {/* Logo */}
      {/* <Box className="imgLogo">
        <img src={templeLogo} alt="temp logo" />
      </Box> */}
    </Box>
  );
}
